import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class AddHeaderInterceptorInterceptor implements HttpInterceptor {

  constructor() {
   
   
  }

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
   // console.log(req);
   
    
      const modifiedReq = req.clone({ 
        headers: req.headers.set('App', 'security-company').set('plateForm','web')
      });
    //  console.log(modifiedReq);
      return next.handle(modifiedReq);
    }


  
}
